export default "__VITE_ASSET__B4TX0JFR__"